//import ReactOwlCarousel from "react-owl-carousel";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css';
import '../../assets/css/owl.css';
import Product from "../product/Product";

const Collection = ({collection}) => {

    const options = {
        margin: 15,
        loop: true,
        responsiveClass: true,
        nav: true,
        dots: false,
        autoplay: false,
        navText: ["Prev", "Next"],
        smartSpeed: 1000,
        responsive: {
            0: {
                items: 2.4,
            },
            400: {
                items: 2.4,
            },
            600: {
                items: 3.2,
            },
            700: {
                items: 4.2,
            },
            1000: {
                items: 5.5,
    
            }
        },
    };

     return (

        <div className="collection-default-loop" key={collection.id}>
            <div className="container">
                <div className="collection-header">
                    <h2 className="collection-title">
                        {collection.title} 
                        <span className="collection-link">View all</span>
                    </h2>
                </div>
                <div className="collection-body">
                <OwlCarousel  className="slider-items owl-carousel" {...options}>
                    {collection.products? 
                    collection.products.map((product) => <Product product={product} key={product.id} />):
                    "Aucun produit pour l'instant."
                    }
                </OwlCarousel>
                </div>
            </div>
        </div>
     );
}

export default Collection;